import { IParameterizable } from './page-service/parameterizable.model';
import { IQueryParams } from './page-service/query-params.model';

export interface ISortingOption {
    id: string;
    name: string;
    active: boolean;
}

export class Sorting implements IParameterizable {
    options: ISortingOption[] = [];

    constructor(options: ISortingOption[]) {
        this.options = options;
    }

    generateParams(): IQueryParams {
        let activeOption = this.options.find((option: ISortingOption) => {
            return option.active;
        });

        if (!activeOption) {
            if (this.options.length === 0) {
                throw new Error('No sorting options available');
            }
            this.options[0].active = true;
            activeOption = this.options[0];
        }

        const pageParams: IQueryParams = {
            queryString: 'sort',
            params: [{ value: activeOption.id }],
        };

        return pageParams;
    }
}
